"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var settings_model_1 = require("../models/settings.model");
var SettingsService = /** @class */ (function () {
    function SettingsService() {
        this.storageKey = 'settings';
        this.settings = JSON.parse(localStorage.getItem(this.storageKey)) || new settings_model_1.Settings();
    }
    Object.defineProperty(SettingsService.prototype, "lastInvitationTimestamp", {
        get: function () {
            return this.settings.lastInvitationTimestamp;
        },
        set: function (value) {
            this.settings.lastInvitationTimestamp = value;
            this.save();
        },
        enumerable: true,
        configurable: true
    });
    SettingsService.prototype.save = function () {
        localStorage.setItem(this.storageKey, JSON.stringify(this.settings));
    };
    return SettingsService;
}());
exports.SettingsService = SettingsService;
